// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2891":"5499e987","3550":"9674ca60","5782":"c6021dea","7261":"ba512490","9287":"65bf238c"}[chunkId] + ".chunk.css";
};